<script lang="ts">
	export let rows = 1;
	export let columns = 5;
</script>

{#each Array(rows) as _}
<div class="grid aisle loading">
	{#each Array(columns) as _}
	<a href={null} class="item"><div class="image"></div><div class="text"></div></a>
	{/each}
</div>
{/each}